function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M4.001 3.843v1.203a.944.944 0 01-.207.704.654.654 0 01-1.028 0L.374 3.743A.74.74 0 01.24 3.63l-.027-.023A.933.933 0 010 3c0-.095.013-.19.04-.282a.823.823 0 01.385-.503L2.765.25a.654.654 0 011.029 0A.945.945 0 014 .954v1.183h11.272c.402 0 .727.382.727.853s-.325.853-.727.853H4z",
  fill: "currentColor"
});

var SvgArrowPrevSmall = function SvgArrowPrevSmall(props) {
  return React.createElement("svg", _extends({
    width: 16,
    height: 6,
    viewBox: "0 0 16 6",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='16' height='6' viewBox='0 0 16 6' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath fill-rule='evenodd' clip-rule='evenodd' d='M4.00141 3.8428V5.04622C4.02678 5.29685 3.95759 5.55808 3.7938 5.7503C3.51002 6.08339 3.0498 6.08321 2.76581 5.74991L0.374314 3.74251C0.326836 3.71161 0.281683 3.67399 0.239866 3.62965L0.213106 3.60719C0.0702752 3.43957 -0.000761802 3.2196 6.16009e-06 2.99998C-0.000327149 2.90465 0.0128655 2.80927 0.0395833 2.71812C0.103565 2.49478 0.244215 2.31275 0.424848 2.21503L2.76581 0.250129C3.0498 -0.0832059 3.51002 -0.0833851 3.7938 0.249645C3.95759 0.44194 4.02678 0.703175 4.00141 0.953794V2.13704H15.2728C15.6745 2.13704 16 2.51889 16 2.98997C16 3.461 15.6745 3.8428 15.2728 3.8428H4.00141Z' fill='currentColor' /%3E %3C/svg%3E";
export { SvgArrowPrevSmall as ReactComponent };